import React from 'react';
import IconsComponent from '../../components/icons';

const Icons = () => (
  <React.Fragment>
    <div className="page-header">
      <p>Core</p>
      <h1>Icons</h1>
    </div>
    <div className="page-content page--icons">
      <IconsComponent />
    </div>
  </React.Fragment>
)

export default Icons
